import * as React from 'react';
import injectSheet from 'react-jss';
import Select from 'src/components/common/Select';
import Loader from 'src/components/common/Loader';
import { getPorts } from 'src/api/containerTracking';
import { Icon } from 'antd';

const styles =  (theme: any) => ({});

class SearchPorts extends React.PureComponent<any, any>{

  state: any = {
    isSearching: false,
    ports: [],
  };

  renderOptions = () =>  {
    return this.state.isSearching ? null : this.state.ports.map(elem =>
      <Select.Option {...elem} key={elem.key}>{elem.label}</Select.Option>,
    );
  }

  searchTimeOut: any = null;

  handleTextChange = (val) => {
    if (val.length >= 0) {
      if (this.searchTimeOut) {
        clearTimeout(this.searchTimeOut);
      }
      this.setState({
        isSearching: true,
      });
      this.searchTimeOut = setTimeout(() => {
        this.searchForData(val);
      }, 300);
    } else if (this.searchTimeOut) {
      clearTimeout(this.searchTimeOut);
    }
  }

  searchForData = async (queryString) => {
    const { portTypes, portApi } = this.props;
    if (!this.state.isSearching) {
      this.setState({
        isSearching: true,
      });
    }
    const response = await getPorts({ queryString, type: portTypes || ['DRY', 'WET'] }, portApi);
    if (response.isSuccess) {
      this.setState({
        isSearching: false,
        ports: response.data.map(el => ({
          key: el.code,
          label: el.name.concat(' (', `${el.code}`, ')'),
        })),
      });
    } else this.setState({ isSearching: false });
  }

  handleFocus = () => {
    const { value } = this.props;
    if (!value || !value.label) {
      this.handleTextChange('');
    } else if (value && !(this.state.ports && this.state.ports.length)) {
      this.handleTextChange(value.label || value);
    }
  }

  render() {
    const { isSearching } = this.state;
    return <Select
          {...this.props}
          showSearch
          labelInValue
          allowClear={true}
          clearIcon={<Icon type="close-circle" theme="filled"
          style={{ fontSize: '12px' }}
          onClick={(e) => {
            this.handleTextChange('');
          }}/>}
          onFocus={this.handleFocus}
          onSearch={this.handleTextChange}
          notFoundContent={isSearching ? <div style={{ padding: '25px' }}><Loader /></div> :
            'Not Found'}
          filterOption={(inputVal, option: any) => {
            if (!inputVal) {
              return true;
            }
            const optionval = option.props.children ? option.props.children.trim()
            .toLowerCase() : '';
            return optionval.includes(inputVal.trim().toLowerCase());
          }}
        >
        {
          this.renderOptions()
        }
        </Select>;
  }
}

export default injectSheet(styles)(SearchPorts);
